<template>
	<div class="contact">
		<!-- BIG SLOGAN -->
		<div class="container">
			<h1 class="big-slogan-blue">{{ $t("contact.pageHeader") }}</h1>
		</div><!-- .container -->

		<!-- CONTACT US -->
		<div class="container">
			<div class="row">
				<div class="col-md-9">
					<div class="all-categories mb-20">
						<strong>{{ $t("contact.contactUs") }}</strong>
					</div>
					<p class="lead">
            {{ $t('at') }} <sub><span class="logo-font domore-yellow">do</span><span class="logo-font domore-blue-1">MORE</span></sub>
            , {{ $t('contact.mission') }}
          </p>
          <p>{{ $t("contact.description") }}</p>
					<div class="row domore-blue-1-light-bgd mt-20 mb-20 pt-10 m-0">
						<div class="col-md-2">
							<p><strong>{{ $t("contact.companyName") }}</strong></p>
						</div><!-- .col-md-2 -->
						<div class="col-md-5">
							<p>{{ $t("contact.address") }}</p>
						</div><!-- .col-md-5 -->
						<div class="col-md-3">
							<p><i class="fa fa-phone-square" aria-hidden="true"></i>{{ $t("contact.phoneNumber") }}</p>
						</div><!-- .col-md-3 -->
						<div class="col-md-2">
							<p><a href="info@domore.live">{{ $t("contact.email") }}</a></p>
						</div><!-- .col-md-2 -->
					</div><!-- .row -->
					<p class="lead">{{ $t("contact.sloganBottom") }}</p>
				</div><!-- .col-md-9 -->
				<div class="col-md-3">
					<div class="all-categories mb-20">
						<strong>{{ $t("contactForm.title") }}</strong>
					</div>
					<form>
						<input type="text" class="form-control mb-20" id="guest-email" :placeholder="$t('contactForm.email')">
						<input type="text" class="form-control mb-20" id="guest-subject" :placeholder="$t('contactForm.subject')">
						<textarea class="form-control" rows="8" id="guest-comment" :placeholder="$t('contactForm.message')"></textarea>
						<button type="button" class="btn btn-default btn-lg button-wide-crowd">{{ $t("contactForm.sendButton") }}</button>
					</form>
				</div><!-- .col-md-3 -->
			</div><!-- .row -->
		</div><!-- .container -->

    <crowd-or-rais></crowd-or-rais>
	</div>
</template>

<script>
import CrowdOrRais from '@/components/CrowdOrRais';

export default {
  components: { CrowdOrRais },
};
</script>



// WEBPACK FOOTER //
// Contact.vue?8bb3c456